import styles from "./errorMessage.module.scss";
import React from "react";

export default function ErrorMessage({text, tag = false}) {
  return (
    <>
      {
        tag ?
        <div className={styles.ErrorMessage} dangerouslySetInnerHTML={{__html: text}} />
        :
        <span className={styles.ErrorMessage}>{text}</span>
      }
    </>
  )
}